<template>
    <div v-if="permission" class="md-content">
        <toolbar title="Informations de la permission">
            <md-button class="md-mr-3 md-primary md-icon-button">
                <md-icon>more_vert</md-icon>
            </md-button>
        </toolbar>
        <div class="md-mt-5 md-layout md-gutter md-alignment-top-center">
            <div class="md-layout-item md-size-45 md-small-size-90 ">
                <div class="md-layout md-layout-item md-size-90 ">
                    <h3>Titre</h3>
                </div>
                <label>{{permission.title}}</label><br>
                <div class="md-layout md-layout-item md-size-90 title">
                    <h3>Code</h3>
                </div>
                <label>{{permission.name}}</label><br>
            </div>

            <div class="md-layout-item md-size-45 md-small-size-90 ">
                <div class="md-layout md-layout-item md-size-90 ">
                    <h3>Description</h3>
                </div>
                <label>{{permission.description}}</label><br>
            </div>
        </div>
    </div>
</template>
<style scoped>
    h3 {
        margin-right: 5px;
    }

    .title {
        margin-top: 15px;
    }

    label {
        color: rgba(0,0,0,0.54);
        font-size: 16px;
    }
</style>
<script>
    import baseToolbar from '@/components/toolbarBase.vue';

    import { apiSecurityExtension } from '@/mixins/apiSecurityExtension.js';

    export default {
        name: 'permissionItem',
        mixins: [apiSecurityExtension],
        data: () => ({
            permission: {},
        }),
        mounted:
            function () {
                this.dataRead();
            },
        methods: {
            dataRead: async function () {

                let data = await this.SecurityPermissionGetById(this.$route.params.id);
                if (data) {
                    this.permission = data;
                }
            },
        },
        components: {
            toolbar: baseToolbar
        }
    }
</script>